// Statuses for which the time left before closing is worth showing.
const COUNTDOWN_VISIBLE_STATUSES = ['active', 'planning', 'planned'];

export function isClosingCountdownVisible(status) {
  return COUNTDOWN_VISIBLE_STATUSES.includes(status);
}

export function getClosingCountdownTone(daysBeforeClosing) {
  let nbOfDays;
  if (Array.isArray(daysBeforeClosing)) nbOfDays = daysBeforeClosing[0];
  else nbOfDays = daysBeforeClosing;
  if (typeof nbOfDays !== 'number' || Number.isNaN(nbOfDays)) return 'destructive';
  if (nbOfDays <= 7) return 'destructive';
  if (nbOfDays <= 15 && nbOfDays >= 8) return 'warning';
  return 'success';
}
